<template>
  <BModalConfirm
    ref="modal"
    v-bind="$attrs"
    :title-text="title"
    :cancel-btn="successMessage ? 'Закрыть' : 'Отменить'"
    successless
    @closed="$emit('closed')"
  >
    <v-overlay
      :value="isLoading"
      absolute
      color="white"
    >
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      />
    </v-overlay>

    <template v-if="!successMessage">
      <div class="ml-1 mb-2">
        <a
          v-if="fileTemplateUrl"
          :href="fileTemplateUrl"
          download="Шаблон для импорта пользователей.xlsx"
          target="_blank"
        >
          Скачать Шаблон файла
        </a>
      </div>
      <BFileUpload
        :value="file"
        :upload-file="uploadFile"
        :error-message="errorMessage"
      />
      <div class="ml-1 mt-2">
        Столбцы Логин, ФИО, Пароль, Принадлежность к АТЕ являются обязательными.
        <br>
        В столбце Принадлежность к АТЕ указывается:
        <ul>
          <li>
            логин ОО, если пользователь соответствует ОО;
          </li>
          <li>
            код региона или код муниципалитета, если пользователь соответствует Региону/Муниципалитету.
          </li>
        </ul>
        Пароль: любая комбинация символов (не менее 10).
      </div>
    </template>

    <div
      v-if="successMessage"
      v-html="successMessage"
    />

    <div
      v-else-if="errorMessage"
      class="error--text ml-8"
      v-text="errorMessage"
    />
  </BModalConfirm>
</template>

<script>
import { UsersApi } from '@/api/resources/UsersApi'
import UsersModalUploadPermissionsFile from './UsersModalUploadPermissionsFile.vue'


export default {
  name: 'UsersModalUploadUsersFile',
  extends: UsersModalUploadPermissionsFile,
  props: {
    title: {
      type: String,
      default: 'Импорт пользователей',
    },
    request: {
      type: Function,
      default: (...args) => {
        const api = new UsersApi()
        return api.importUsers(...args)
      },
    },
    fileTemplateUrl: {
      type: String,
      default: '/files/users_import.xlsx',
    },
  },
}
</script>
